import api from './api';

export const unitImportService = {
  /**
   * Download unit import template
   */
  downloadTemplate: async (workspaceId: string, format: 'xlsx' | 'csv' = 'xlsx'): Promise<Blob> => {
    const response = await api.get(`/workspaces/${workspaceId}/units/import/template`, {
      params: { format },
      responseType: 'blob'
    });
    return response.data;
  },

  /**
   * Parse uploaded unit file
   */
  parseFile: async (workspaceId: string, file: File, projectId: string): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    formData.append('workspaceId', workspaceId);

    const response = await api.post(`/workspaces/${workspaceId}/units/import/parse`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  /**
   * Bulk create units from parsed data
   */
  bulkCreate: async (
    workspaceId: string,
    projectId: string,
    builderId: string,
    rows: any[]
  ): Promise<any> => {
    const response = await api.post(`/workspaces/${workspaceId}/units/import/bulk-create`, {
      projectId,
      builderId,
      rows
    });
    return response.data;
  }
};
